import { Outlet, Link, useNavigate, useLocation } from "react-router-dom";
import logo from "../../assets/logo/1.jpg";
import armicon from "../../assets/languageicons/arm.png";
import rusicon from "../../assets/languageicons/ru.png";
import enicon from "../../assets/languageicons/en.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faXmark,
  faRightToBracket,
} from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { useState, useEffect, useRef, useContext } from "react";
import { UserContext } from "../../components/usercontext/user_context";
import Footer from "../footer/footer";
import Modal from "../modal/modal";

const Layout = ({ hideHeader = false }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useContext(UserContext);
  const { t, i18n } = useTranslation();
  const isAdminPage = location.pathname.startsWith("/Admin_Page");

  const [showFooter, setShowFooter] = useState(false);
  const [open, setOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [logoutModalOpen, setLogoutModalOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => setShowFooter(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

const getUserAvatar = (user) => {
  // 1. Если пользователя нет, возвращаем дефолт из папки public фронтенда
  if (!user) return "/default-avatar.png";

  // 2. Если это работник И у него загружено фото — показываем фото
  if (user.role === "worker") {
    return user.photo ? `/api/uploads/${user.photo}` : "/default-avatar.png";
  }

  // 3. Если это компания
  if (user.role === "company") {
    // Делаем тройную проверку полей на случай, если в localStorage записалось другое имя поля
    const companyLogoFile = user.companyLogo || user.photo || user.logo;
    
    return companyLogoFile ? `/api/uploads/${companyLogoFile}` : "/default-avatar.png";
  }

  return "/default-avatar.png";
};
  const handleLogoutClick = () => {
    setDropdownOpen(false);
    setLogoutModalOpen(true);
  };
  const handleDropdownLinkClick = () => {
    setDropdownOpen(false);
    setOpen(false);
  };
  const handleLogoutClickMobile = () => {
    setOpen(false);
    setLogoutModalOpen(true);
  };
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);
  const confirmLogout = () => {
    logout();
    setLogoutModalOpen(false);
    navigate("/");
  };
  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 150);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="flex flex-col min-h-screen">
      {!isAdminPage && (
        <header className="bg-[#006674] z-[99999] flex justify-between opacity-0 animate-[showheader_1s_forwards] relative text-white p-2 items-center">
          <Link to="/" className="w-[60px] h-[60px] hidden max-lg:block">
            <img src={logo} alt="logo" className="size-full object-cover" />
          </Link>

          {logoutModalOpen && (
            <Modal
              title="Դուրս գալ"
              text="Վստա՞հ եք, որ ցանկանում եք դուրս գալ"
              type="logout"
              actions={[
                { label: "Այո", onClick: confirmLogout, success: true },
                {
                  label: "Ոչ",
                  onClick: () => setLogoutModalOpen(false),
                  success: false,
                },
              ]}
            />
          )}

          {/* меню */}
          <div
            className={`w-full max-lg:w-[300px] max-sm:w-full flex justify-between items-center bg-[#006674] p-3 gap-3
    max-lg:shadow-xl max-lg:flex-col max-lg:absolute max-lg:right-0 max-lg:top-full 
    max-lg:overflow-hidden max-lg:transition-all max-lg:duration-300 max-lg:ease-in-out 
    ${
      open
        ? "max-lg:max-h-[500px] max-lg:opacity-100 max-lg:translate-y-0"
        : "max-lg:max-h-0 max-lg:opacity-0 max-lg:-translate-y-5"
    }`}
          >
            {user && (
              <div
                className="relative lg:hidden max-lg:w-full max-lg:flex justify-center items-center flex-col"
                ref={dropdownRef}
              >
                {/* dropdown mobile */}
                <div className="absolute max-lg:static max-lg:w-full bg-[#006674] flex flex-col gap-3 p-2 max-sm:p-0 rounded-xl">
                  {user.role === "worker" && (
                    <>
                      <Link
                        to="/workerprofile"
                        onClick={() => setOpen(false)}
                        className="block text-white border-2 border-white rounded-full text-center px-4 py-2 hover:bg-[#00525a]"
                      >
                        {t("mypage")}
                      </Link>
                      <Link
                        to="/settings"
                        onClick={() => setOpen(false)}
                        className="block text-white border-2 border-white rounded-full text-center px-4 py-2 hover:bg-[#00525a]"
                      >
                        {t("settings")}
                      </Link>
                    </>
                  )}

                  {user.role === "company" && (
                    <>
                      <Link
                        to="/employerprofile"
                        onClick={() => setOpen(false)}
                        className="block text-white border-2 border-white rounded-full text-center px-4 py-2 hover:bg-[#00525a]"
                      >
                        {t("personal")}
                      </Link>
                      <Link
                        to={`/employerSettings?id=${user.id}`}
                        onClick={() => setOpen(false)}
                        className="block text-white border-2 border-white rounded-full text-center px-4 py-2 hover:bg-[#00525a]"
                      >
                        {t("settings")}
                      </Link>
                    </>
                  )}
                </div>
              </div>
            )}

            <nav className="flex justify-start max-lg:w-full items-center gap-3">
              <Link to="/" className="w-auto h-[60px] max-lg:hidden">
                <img src={logo} alt="logo" className="size-full object-cover" />
              </Link>
              <ul className="flex justify-center items-center gap-3 max-lg:flex-col max-lg:w-full">
                <li className="max-lg:w-full">
                  <Link
                    to="/Companies"
                    onClick={() => setOpen(false)}
                    className="px-3 py-2 max-lg:justify-center flex border-2 border-white hover:bg-white hover:text-[#006674] rounded-[30px] transition"
                  >
                    {t("companies")}
                  </Link>
                </li>
                <li className="max-lg:w-full">
                  <Link
                    to="/Top_Candidates"
                    onClick={() => setOpen(false)}
                    className="px-3 py-2 max-lg:justify-center flex border-2 border-white hover:bg-white hover:text-[#006674] rounded-[30px] transition"
                  >
                    {t("TOPcandidates")}
                  </Link>
                </li>
                <li className="max-lg:w-full">
                  <Link
                    to="/Global_News"
                    onClick={() => setOpen(false)}
                    className="px-3 py-2 max-lg:justify-center flex border-2 border-white hover:bg-white hover:text-[#006674] rounded-[30px] transition"
                  >
                    {t("news")}
                  </Link>
                </li>
              </ul>
            </nav>

            <hr className="w-full h-[1px] lg:hidden max:lg-flex my-3 bg-white" />

            {user ? (
              <button
                onClick={handleLogoutClickMobile}
                className="w-full text-white lg:hidden max-lg:block text-center rounded-full px-4 py-2 hover:bg-red-600 hover:text-white"
              >
                {t("logout")} <FontAwesomeIcon icon={faRightToBracket} />
              </button>
            ) : (
              <Link
                onClick={() => setOpen(false)}
                to="/registerchoose"
                className="py-2 px-4 lg:hidden max-md:w-full max-lg:flex justify-center items-center w-[200px] text-center rounded-[30px] bg-white text-[#006674] hover:bg-[#848484] hover:text-white transition"
              >
                {t("login")}
              </Link>
            )}
          </div>

          {/* бургер */}
          <div className="flex items-center gap-6">
            <nav className=" items-center gap-3 max-lg:flex-col">
              <ul className="flex">
                {[
                  { lang: "am", icon: armicon },
                  { lang: "ru", icon: rusicon },
                  { lang: "en", icon: enicon },
                ].map(({ lang, icon }) => (
                  <li key={lang}>
                    <button
                      className="w-[40px] h-[40px]"
                      onClick={() => {
                        i18n.changeLanguage(lang);
                      }}
                    >
                      <img
                        src={icon}
                        className="size-full object-contain rounded-full"
                        alt={lang}
                      />
                    </button>
                  </li>
                ))}
              </ul>
            </nav>

            <button
              className="hidden p-2 w-[40px] h-[40px] max-lg:flex justify-center items-center border border-white rounded"
              onClick={() => setOpen(!open)}
            >
              {open ? (
                <FontAwesomeIcon icon={faXmark} />
              ) : (
                <FontAwesomeIcon icon={faBars} />
              )}
            </button>

            {user ? (
              <div
                className="relative max-lg:w-full max-lg:hidden justify-center items-center flex-col"
                ref={dropdownRef}
              >
                <button
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                  className="w-[45px] max-lg:w-[150px] max-lg:h-[150px] h-[45px] rounded-full border-2 border-white overflow-hidden"
                >
                  <img
                    src={getUserAvatar(user)}
                    alt="user"
                    className="w-full h-full object-cover"
                  />
                </button>

                {dropdownOpen && (
                  <div className="absolute max-lg:static max-lg:w-full transition-all right-0 mt-2 w-48 bg-[#006674] p-3 flex flex-col gap-3 text-white rounded-lg shadow-lg overflow-hidden">
                    {user?.role === "worker" && (
                      <Link
                        to="/workerprofile"
                        onClick={() => {
                          setOpen(false);
                          handleDropdownLinkClick();
                        }}
                        className="block px-4 py-2 hover:bg-white border-[1px] border-white transition-all duration-200 rounded-full hover:text-[#006674]"
                      >
                        {t("mypage")}
                      </Link>
                    )}

                    {user?.role === "company" &&
                      location.pathname !== "/employerprofile" && (
                        <Link
                          to="/employerprofile"
                          onClick={() => {
                            setOpen(false);
                            handleDropdownLinkClick();
                          }}
                          className="block px-4 py-2 hover:bg-white border-[1px] transition-all duration-200 border-white rounded-full hover:text-[#006674]"
                        >
                          {t("personal")}
                        </Link>
                      )}

                    <Link
                      to={
                        user?.role === "worker"
                          ? "/settings"
                          : `/employerSettings?id=${user.id}`
                      }
                      onClick={() => {
                        setOpen(false);
                        handleDropdownLinkClick();
                      }}
                      className="block px-4 py-2 hover:bg-white border-[1px] transition-all duration-200 border-white rounded-full hover:text-[#006674]"
                    >
                      {t("settings")}
                    </Link>

                    <hr />
                    <button
                      onClick={() => {
                        setOpen(false);
                        handleLogoutClick();
                      }}
                      className="w-full text-left rounded-full transition-all duration-200 px-4 py-2 hover:bg-red-600 hover:text-white"
                    >
                      {t("logout")} <FontAwesomeIcon icon={faRightToBracket} />
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <Link
                onClick={() => setOpen(false)}
                to="/registerchoose"
                className="py-2 px-4 max-lg:hidden w-[200px] text-center rounded-[30px] bg-white text-[#006674] hover:bg-[#848484] hover:text-white transition"
              >
                {t("login")}
              </Link>
            )}
          </div>
        </header>
      )}
      <main className="flex-1 min-h-[calc(100vh-180px)]">
        <Outlet />
      </main>

      {showFooter && <Footer />}
    </section>
  );
};

export default Layout;
